var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMacadamiaNuts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "macadamia_nuts",
    width: "100%",
    height: "100%",
    viewBox: "0 0 100 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noix de macadamia") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noix-de-macadamia",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#000000",
    strokeWidth: 2,
    cx: 50,
    cy: 38,
    r: 37
  }), /*#__PURE__*/React.createElement("text", {
    id: "macadamia",
    xmlSpace: "preserve",
    x: -2,
    y: 121,
    fontFamily: "OpenSansCondensed-Bold, Open Sans Condensed",
    fontSize: 20,
    fontWeight: 500,
    fill: "#000000"
  }, "macadamia"), /*#__PURE__*/React.createElement("text", {
    id: "noix-de",
    xmlSpace: "preserve",
    x: 16,
    y: 99,
    fontFamily: "OpenSansCondensed-Bold, Open Sans Condensed",
    fontSize: 20,
    fill: "#000000"
  }, "noix de"), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(30.177000, 15.077000)",
    fill: "#161615"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.823,44.2567345 C10.2631627,44.2567345 2.48514679,36.4594449 2.48514679,26.8759187 C2.48514679,19.6509914 7.03693579,13.1067335 13.811015,10.5915057 C13.867528,10.5706774 13.9190546,10.5440172 13.9672568,10.5131913 C16.2078307,9.63673558 17.082951,7.2698054 17.8591736,5.17281023 C18.0843945,4.56212391 18.2979803,3.98642917 18.5306809,3.48488325 C18.9246097,2.64008663 19.7199469,2.59176493 19.8487633,2.58926553 C19.8579051,2.58926553 20.7097553,2.61342638 21.1153191,3.48488325 C21.3488508,3.98642917 21.5624366,4.56295705 21.7884886,5.1744765 C22.563049,7.26813913 23.4381693,9.63256992 25.6737567,10.5106919 C25.7236211,10.543184 25.7776409,10.5698443 25.834985,10.5915057 C32.6090642,13.1067335 37.1608532,19.6509914 37.1608532,26.8759187 C37.1608532,36.4594449 29.3828373,44.2567345 19.823,44.2567345 Z M26.6884973,9.13435653 C26.5970793,9.06853904 26.4915329,9.02021734 26.3776759,8.99605649 C24.7620692,8.42119488 24.0431907,6.47666301 23.3467512,4.59378296 C23.1090642,3.9514376 22.8838433,3.34325068 22.6220552,2.78088606 C21.9389129,1.3145724 20.5576689,0.923 19.7980678,0.923 C19.0891622,0.923 17.7079182,1.3145724 17.0247759,2.78088606 C16.7629878,3.34325068 16.5377669,3.95060447 16.3000799,4.59294983 C15.5944986,6.50082386 14.8648161,8.47451538 13.2026693,9.01771794 C13.1295349,9.04187879 13.0622179,9.0752041 13.0032117,9.1160276 C5.70721835,11.9345157 0.823,19.039472 0.823,26.8759187 C0.823,37.3783904 9.34648876,45.923 19.823,45.923 C30.2995112,45.923 38.823,37.3783904 38.823,26.8759187 C38.823,19.0561346 33.9587274,11.9636754 26.6884973,9.13435653 L26.6884973,9.13435653 Z",
    id: "Fill-33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.823,40.2579447 C12.4749337,40.2579447 6.49720057,34.3120321 6.49720057,27.0049368 C6.49720057,17.604867 17.6540732,12.5880553 19.823,12.5880553 C23.2484144,12.5880553 33.1487994,18.2509085 33.1487994,27.0049368 C33.1487994,34.3120321 27.1710663,40.2579447 19.823,40.2579447 Z M19.823,10.923 C16.2067268,10.923 4.823,16.8031429 4.823,27.0049368 C4.823,35.2311427 11.5524492,41.923 19.823,41.923 C28.0935508,41.923 34.823,35.2311427 34.823,27.0049368 C34.823,17.3326305 24.1491343,10.923 19.823,10.923 L19.823,10.923 Z",
    id: "Fill-34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.823,36.2542171 C14.6709964,36.2542171 10.4801256,32.0338652 10.4801256,26.8481224 C10.4801256,20.1613095 18.3025872,16.5917829 19.823,16.5917829 C21.8231506,16.5917829 29.1658744,20.3256846 29.1658744,26.8481224 C29.1658744,32.0338652 24.9750036,36.2542171 19.823,36.2542171 Z M19.823,14.923 C17.1707704,14.923 8.823,19.2835297 8.823,26.8481224 C8.823,32.9550334 13.7579202,37.923 19.823,37.923 C25.8880798,37.923 30.823,32.9550334 30.823,26.8481224 C30.823,19.6756936 22.995567,14.923 19.823,14.923 L19.823,14.923 Z",
    id: "Fill-35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8924545,31.3276173 C16.5186739,31.6504643 15.5623405,28.6513648 15.5192236,28.5091865 C15.3984962,28.091292 14.9311088,27.8367849 14.4697577,27.9498992 C14.0084066,28.0575149 13.731596,28.4864065 13.8505987,28.9066575 C14.2602094,30.3480791 16.1168241,32.923 20.2629474,32.923 C20.5095762,32.923 20.7656907,32.9135738 21.028704,32.8947214 C21.5038525,32.8601587 21.8574112,32.4815401 21.8203307,32.0487209 C21.7823878,31.6174727 21.3684653,31.3001243 20.8924545,31.3276173",
    id: "Fill-36"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMacadamiaNuts);
export default __webpack_public_path__ + "static/media/macadamia_nuts.1d3070edc04fd5e739beb2b0bf3742b8.svg";
export { ForwardRef as ReactComponent };